import React, { Component } from 'react';
import { get, post } from 'axios';
import SettingsBusiness from './SettingsBusiness';
import SettingsServices from './SettingsServices';
import SettingsTeam from './SettingsTeam';
import SettingsBooking from './SettingsBooking';
import SettingsEmail from './SettingsEmail';
import SettingsPayments from './SettingsPayments';
import SettingsDocument from './SettingsDocument';
import { inject, observer } from 'mobx-react';

@inject('userStore')
class Settings extends Component {
    constructor(props){
        super(props);
        this.state = {
            active:'business',
            business:null,
            sys_state_list:[],
            component:null
        }
        this.select = this.select.bind(this);
    }

    select(option){
        switch (option) {
            case 'business':
                this.setState({
                    active:option,
                    component:<SettingsBusiness business={this.state.business} sys_state_list={this.state.sys_state_list}/>
                });
                break;
            case 'payments':
                this.setState({
                    active:option,
                    component:<SettingsPayments business={this.state.business}/>
                });
                break;
            case 'services':
                this.setState({
                    active:option,
                    component:<SettingsServices business={this.state.business} sys_calculate_type_list={this.state.sys_calculate_type_list} sys_lineitem_type_list={this.state.sys_lineitem_type_list}/>
                });
                break;
            case 'team':
                this.setState({
                    active:option,
                    component:<SettingsTeam business={this.state.business}/>
                });
                break;
            case 'booking':
                this.setState({
                    active:option,
                    component:<SettingsBooking business={this.state.business}/>
                });
                break;
            case 'emails':
                this.setState({
                    active:option,
                    component:<SettingsEmail business={this.state.business}/>
                });
                break;
            case 'document':
                this.setState({
                    active:option,
                    component:<SettingsDocument business={this.state.business}/>
                });
                break;
            default:

        }
    }

    componentDidMount(){
        post('/v2/get/business', {business_hash_id: this.props.userStore.business_primary.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            this.setState({business:res.data.business, sys_state_list:res.data.sys_state_list, sys_lineitem_type_list:res.data.sys_lineitem_type_list, sys_calculate_type_list:res.data.sys_calculate_type_list}, ()=>this.select('business'));
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }


    render(){
      const {business} = this.state;
        return (
        <React.Fragment>
            <aside className="aside aside-expand-md">
            <div className="aside-body ps-container ps-theme-default" data-ps-id="d36e4d80-cb31-8fae-9802-5e3c8cbdebfe">
            {business === null ? <span className="ml-20 mt-10">Loading...</span> :
              <ul className="nav nav-lg nav-pills flex-column">
                <li className={this.state.active === 'business' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-building"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('business')}>Business</a>
                </li>
                <li className={this.state.active === 'payments' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-money"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('payments')}>Payment Options</a>
                </li>
                <li className={this.state.active === 'services' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-scissors"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('services')}>Services & Line Items</a>
                </li>

                <li className={this.state.active === 'booking' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-exclamation-circle"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('booking')}>Booking Information</a>
                </li>

                <li className={this.state.active === 'team' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-users"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('team')}>Team</a>
                </li>

                <li className={this.state.active === 'emails' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-envelope"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('emails')}>Emails</a>
                </li>
                <li className={this.state.active === 'document' ? "nav-item active": "nav-item"}>
                  <i className="fa fa-file-pdf-o"></i>
                  <a className="nav-link" href="#" onClick={() => this.select('document')}>Documents</a>
                </li>
              </ul>
            }
              <hr/>
              <div className="aside-block">
                <div className="flexbox align-items-center mb-1">
                </div>
              </div>
                <div className="ps-scrollbar-x-rail" style={{"left": 0+"px", "bottom": 0+"px"}}>
                    <div className="ps-scrollbar-x" style={{"left": 0+"px", "width": 0+"px"}}></div>
                </div>
                <div className="ps-scrollbar-y-rail" style={{"top": 0+"px", "right": 2+"px"}}>
                    <div className="ps-scrollbar-y" style={{"top": 0+"px", "height": 0+"px"}}></div>
                </div>
            </div>
            <button className="aside-toggler"></button>
          </aside>
          <div className="main-content">
          {this.state.component ? this.state.component : <div>Loading</div>}
          </div>
      </React.Fragment>);
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/business/Settings.js